const gout_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },

   {
      "question":"Does ##name## have any signs or symptoms due to any esophageal condition (including GERD)?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":3,
      "dbqName_yes":"F[0].#subform[1].Yes3[0]",
      "dbqName_no":"F[0].#subform[1].No3[0]",
      "answer":"",
   },
   {
      "question":"Symptoms of impairment of health",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "refId":1,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS AND SYMPTOMS",
         number: "3"
      },
      "cols": 2,
      "small": true,
      "questions":[
         {
            "main":"Symptoms productive of considerable impairment of health",
            "dbqName":"F[0].#subform[1].PERSISTENTLYRECURRENTEPIGASTRICDISTRESS[3]",
            "answer":""
         },
         {
            "main":"Symptoms combination productive of severe impairment of health",
            "dbqName":"F[0].#subform[1].PERSISTENTLYRECURRENTEPIGASTRICDISTRESS[2]",
            "answer":""
         }      
      ],
      "answer":""
   },
   {
      "question":"Symptoms of Epigastric distress",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "refId":2,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS AND SYMPTOMS",
         number: "3"
      },
      "cols": 2,
      "small": true,
      "questions":[
         {
            "main":"Persistently recurrent epigastric distress",
            "dbqName":"F[0].#subform[1].PERSISTENTLYRECURRENTEPIGASTRICDISTRESS[0]",
            "answer":""
         },
         {
            "main":"Infrequent episodes of epigastric distress",
            "dbqName":"F[0].#subform[1].PERSISTENTLYRECURRENTEPIGASTRICDISTRESS[1]",
            "answer":""
         }      
      ],
      "answer":""
   },
   {
      "question":"Has ##name## been treated with medication in the past 12 months for any skin condition?",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "show": false,
      "refId":3,
      "small": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS AND SYMPTOMS",
         number: "3"
      },
      "questions":[
         {
            "main":"Dysphagia",
            "dbqName":"F[0].#subform[1].DYSPHAGIA[0]",
            "answer":"",
         },
         {
            "main":"Pyrosis",
            "dbqName":"F[0].#subform[1].PYROSISHeartburn[0]",
            "answer":"",
         },
         {
            "main":"Reflux",
            "dbqName":"F[0].#subform[1].REFLUX[0]",
            "answer":"",
         },
         {
            "main":"Regurgitation",
            "dbqName":"F[0].#subform[1].REGURGITATION[0]",
            "answer":"",
         },
         {
            "main":"Pain",
            "dbqName":"F[0].#subform[1].SUBSTERNALARMORSHOULDERPAIN[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Substernal",
                  "dbqName":"F[0].#subform[1].Ones[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Arm",
                  "dbqName":"F[0].#subform[1].Ones[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"Shoulder",
                  "dbqName":"F[0].#subform[1].Ones[2]",
                  "colWidth": 4,
                  "answer":""
               },
            ],
            "subAnswer":"",
            "subItemsLabel" :"Area of Pain",
            // "subItemOther": false,
            // "textOther": "",
            // "dbqNameOther": "F[0].Page_4[0].TextField35[1]",
            // "placeholderOther":"Describe penis deformity",
         }, 
         {
            "main":"Sleep disturbance cause by esophageal reflux",
            "dbqName":"F[0].#subform[1].SLEEPDISTURBANCECAUSEBYESOPHAGEALREFLUX[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            // "text1": "",
            // "dbqName1": "F[0].Page_3[0].ifchecked1[0]",
            // "text2": "",
            // "dbqName2": "F[0].Page_3[0].speccond1[0]",
            "subItems": [
               {
                  "main":"1",
                  "dbqName":"F[0].#subform[1].Onel[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].#subform[1].Twol[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].#subform[1].Threel[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].#subform[1].Fourl[0]",
                  "colWidth": 3,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency of symptom recurrence per year",
            // "subItemOther": false,
            // "textOther": "",
            // "dbqNameOther": "F[0].Page_3[0].Other[0]",
            "subItems2": [
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].#subform[1].lessl[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"1-9 days",
                  "dbqName":"F[0].#subform[1].onel[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].#subform[1].tenl[0]",
                  "colWidth": 4,
                  "answer":""
               },
            ],
            "subAnswer2":"",
            "subItems2Label" :" indicate average duration of episodes of symptoms",
         },
         {
            "main":"Material weight loss",
            "dbqName":"F[0].#subform[1].WEIGHTLOSS[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "text1": "",
            "dbqName1": "F[0].#subform[1].baselineweight[0]",
            "placeholder1": "provide baseline weight",
            "text2": "",
            "dbqName2": "F[0].#subform[1].andcurrentweight[0]",
            "placeholder2": "provide current weight",
         },

         {
            "main":"Nausea",
            "dbqName":"F[0].Page_2[0].NAUSEA[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].Onen[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Twon[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Threen[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Fourn[0]",
                  "colWidth": 3,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency of symptom recurrence per year",
            "subItems2": [
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].lessn[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"1-9 days",
                  "dbqName":"F[0].Page_2[0].onen[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].tenn[0]",
                  "colWidth": 4,
                  "answer":""
               },
            ],
            "subAnswer2":"",
            "subItems2Label" :" indicate average duration of episodes of symptoms",
         },
         {
            "main":"Vomiting",
            "dbqName":"F[0].Page_2[0].VOMITING[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].Onen[1]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Twon[1]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Threen[1]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Fourn[1]",
                  "colWidth": 3,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency of symptom recurrence per year",
            "subItems2": [
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].lessn[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"1-9 days",
                  "dbqName":"F[0].Page_2[0].onen[1]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].tenn[1]",
                  "colWidth": 4,
                  "answer":""
               },
            ],
            "subAnswer2":"",
            "subItems2Label" :" indicate average duration of episodes of symptoms",
         },
         {
            "main":"Hematemesis",
            "dbqName":"F[0].Page_2[0].HEMATEMESIS[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].Oneh[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Twoh[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Threeh[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Fourh[0]",
                  "colWidth": 3,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency of symptom recurrence per year",
            "subItems2": [
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].lessh[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"1-9 days",
                  "dbqName":"F[0].Page_2[0].oneh[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].tenh[0]",
                  "colWidth": 4,
                  "answer":""
               },
            ],
            "subAnswer2":"",
            "subItems2Label" :" indicate average duration of episodes of symptoms",
         },
         {
            "main":"Melena with moderate anemia",
            "dbqName":"F[0].Page_2[0].MELENA[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].One[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Two[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Three[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Four[0]",
                  "colWidth": 3,
                  "answer":""
               }
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate frequency of symptom recurrence per year",
            "subItems2": [
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].less[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"1-9 days",
                  "dbqName":"F[0].Page_2[0].one[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].ten[0]",
                  "colWidth": 4,
                  "answer":""
               },
            ],
            "subAnswer2":"",
            "subItems2Label" :" indicate average duration of episodes of symptoms",
         }                      
      ],
      "answer":""
   },


   

   {
      "question":"Does ##name## have material weight loss?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].#subform[1].WEIGHTLOSS[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Provide the baseline weight and current weight",
      "sub":"",
      "type":"text",
      "show": false,
      "refId": 1,
      "note":"For VA purposes, baseline weight is the average weight for 2-year period preceding onset of disease",
      "section": {
         page: "3",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "questions":[
         {
            "main":"Baseline weight",
            "subMain":"Average weight for 2-year",
            "type":"text",
            "maxLength" : 3,
            "dbqName":"F[0].#subform[1].baselineweight[0]"
         },
         {
            "main":"Current weight",
            "subMain":"Provide current weight",
            "type":"text",
            "maxLength" : 3,
            "dbqName":"F[0].#subform[1].andcurrentweight[0]"
         },
      ]
   },

   {
      "question":"Does ##name## have sleep disturbance caused by esophageal reflux?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].#subform[1].SLEEPDISTURBANCECAUSEBYESOPHAGEALREFLUX[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Indicate frequency of symptoms along with duration of episodes for ##redHeading## caused by esophageal reflux",
      "redHeading":"sleep disturbance",
      "sub":"",
      "type":"radio",
      "show": false,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "refId":1,
      "questions":[
         {
            "label":"Frequency per year",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"1",
                  "dbqName":"F[0].#subform[1].Onel[0]",
                  "sub":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].#subform[1].Twol[0]",
                  "sub":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].#subform[1].Threel[0]",
                  "sub":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].#subform[1].Fourl[0]",
                  "sub":""
               }
            ],
            "answer":"4 or more"
         },
         {
            "label":"Average duration of episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].#subform[1].lessl[0]",
                  "sub":""
               },
               {
                  "main":"1 - 9 days",
                  "dbqName":"F[0].#subform[1].onel[0]",
                  "sub":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].#subform[1].tenl[0]",
                  "sub":""
               }
            ],
            "answer":"10 days or more"
         }
      ]
   },
   {
      "question":"Does ##name## have nausea due to any esophageal condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].NAUSEA[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Indicate frequency of symptoms along with duration of episodes for ##redHeading##",
      "redHeading":"nausea",
      "sub":"",
      "type":"radio",
      "show": false,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "refId":1,
      "questions":[
         {
            "label":"Frequency per year",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].Onen[0]",
                  "sub":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Twon[0]",
                  "sub":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Threen[0]",
                  "sub":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Fourn[0]",
                  "sub":""
               }
            ],
            "answer":"4 or more"
         },
         {
            "label":"Average duration of episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].lessn[0]",
                  "sub":""
               },
               {
                  "main":"1 - 9 days",
                  "dbqName":"F[0].Page_2[0].onen[0]",
                  "sub":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].tenn[0]",
                  "sub":""
               }
            ],
            "answer":"10 days or more"
         }
      ]
   },
   {
      "question":"Does ##name## have vomiting due to any esophageal condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].VOMITING[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Indicate frequency of symptoms along with duration of episodes for ##redHeading##",
      "redHeading":"vomiting",
      "sub":"",
      "type":"radio",
      "show": false,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "refId":1,
      "questions":[
         {
            "label":"Frequency per year",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].Onen[1]",
                  "sub":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Twon[1]",
                  "sub":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Threen[1]",
                  "sub":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Fourn[1]",
                  "sub":""
               }
            ],
            "answer":"4 or more"
         },
         {
            "label":"Average duration of episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].lessn[1]",
                  "sub":""
               },
               {
                  "main":"1 - 9 days",
                  "dbqName":"F[0].Page_2[0].onen[1]",
                  "sub":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].tenn[1]",
                  "sub":""
               }
            ],
            "answer":"10 days or more"
         }
      ]
   },
   {
      "question":"Does ##name## have hematemesis due to any esophageal condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].HEMATEMESIS[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Indicate frequency of symptoms along with duration of episodes for ##redHeading##",
      "redHeading":"hematemesis",
      "sub":"",
      "type":"radio",
      "show": false,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "refId":1,
      "questions":[
         {
            "label":"Frequency per year",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].Oneh[0]",
                  "sub":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Twoh[0]",
                  "sub":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Threeh[0]",
                  "sub":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Fourh[0]",
                  "sub":""
               }
            ],
            "answer":"4 or more"
         },
         {
            "label":"Average duration of episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].lessh[0]",
                  "sub":""
               },
               {
                  "main":"1 - 9 days",
                  "dbqName":"F[0].Page_2[0].oneh[0]",
                  "sub":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].tenh[0]",
                  "sub":""
               }
            ],
            "answer":"10 days or more"
         }
      ]
   },
   {
      "question":"Does ##name## have melena with moderate anemia due to any esophageal condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_2[0].MELENA[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
   },
   {
      "question":"Indicate frequency of symptoms along with duration of episodes for ##redHeading##",
      "redHeading":"melena with moderate anemia",
      "sub":"",
      "type":"radio",
      "show": false,
      "section": {
         page: "3",
         title: "SIGNS AND SYMPTOMS",
         number: "3A"
      },
      "refId":1,
      "questions":[
         {
            "label":"Frequency per year",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"1",
                  "dbqName":"F[0].Page_2[0].One[0]",
                  "sub":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_2[0].Two[0]",
                  "sub":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_2[0].Three[0]",
                  "sub":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_2[0].Four[0]",
                  "sub":""
               }
            ],
            "answer":"4 or more"
         },
         {
            "label":"Average duration of episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_2[0].less[0]",
                  "sub":""
               },
               {
                  "main":"1 - 9 days",
                  "dbqName":"F[0].Page_2[0].one[0]",
                  "sub":""
               },
               {
                  "main":"10 days or more",
                  "dbqName":"F[0].Page_2[0].ten[0]",
                  "sub":""
               }
            ],
            "answer":"10 days or more"
         }
      ]
   },
   
   
   {
      "question":"Do any of the ##name##'S esophageal conditions impact his or her ability to work?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "FUNCTIONAL IMPACT",
         number: "7"
      },
      "presidence":"Yes",
      "maxLength":810,
      "ref":0,
      "dbqName_yes":"F[0].Page_4[0].Yes7[0]",
      "dbqName_no":"F[0].Page_4[0].No7[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Describe impact of each of the esophageal conditions, providing one ore more examples",
      "textdbqName":"F[0].Page_4[0].ifyesdescribeimpact[0]",
      "textanswer":""
   },
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":1890,
      "show": true,
      "section": {
         page: "5",
         title: "REMARKS",
         number: "8A"
      },
      "options":[],
      "dbqName":"F[0].Page_4[0].REMARKSIfany[0]",
      "answer":""
   },
]
   
    export default gout_questions ;